@let type = resultType();

<ideal-image [src]="imageSrc()" fit="contain"></ideal-image>
<div canadian>
  @if (canadian() === true) {
    <img src="assets/logos/leaf.svg" alt="Canadian" />
  }
</div>
<div price withLoadingSkeleton [isLoading]="priceLoading()">
  <ideal-item-price [itemId]="itemId()" sizing="compact" disableSalesNotice="true" disableFees="true"></ideal-item-price>
</div>
<div
  part-number
  i18n-label="@@inventory.quick-search.part-number.label"
  label="Part Number"
  i18n-short-label="@@inventory.quick-search.part-number.short-label"
  short-label="pn"
  [innerHtml]="partNumberMatched()"
></div>
<div
  description
  i18n-label="@@inventory.quick-search.description.label"
  label="Description"
  i18n-short-label="@@inventory.quick-search.description.short-label"
  short-label="desc"
  [innerHtml]="descriptionMatched()"
></div>

@if (type === "keyword") {
  <div
    keyword-list
    i18n-label="@@inventory.quick-search.keywords.label"
    label="Keywords"
    i18n-short-label="@@inventory.quick-search.keywords.short-label"
    short-label="kw"
  >
    <ideal-keywords-inline [productId]="product().id" [match]="searchTerm()" />
  </div>
}
@if (type === "cross-reference") {
  <div
    cross-reference-list
    i18n-label="@@inventory.quick-search.cross-references.label"
    label="Cross References"
    i18n-short-label="@@inventory.quick-search.cross-references.short-label"
    short-label="refs"
  >
    <ideal-xrefs-inline [productId]="product().id" [match]="searchTerm()" />
  </div>
}

<div stock-container withLoadingSkeleton [isLoading]="stockLoading()">
  <div stock [attr.stock-location]="stockLabel()">
    <div label>{{ stockLabel() }}</div>
  </div>
</div>
